import React from "react";
import {
  FaLightbulb,
  FaGraduationCap,
  FaHandshake,
  FaLeaf,
  FaUsers,
  FaChartLine,
} from "react-icons/fa";
import "../css/about.css";
import Nav from "./nav";
import Footer from "./footer";

const About = () => {
  return (
    <div className="about-page">
      <Nav />


      <div className="about-hero">
        <div className="hero-overlay"></div>

        {/* Particle background effect */}
        <div className="particles">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="particle"
              style={{
                width: `${Math.random() * 5 + 2}px`,
                height: `${Math.random() * 5 + 2}px`,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100 + 100}%`,
                animationDuration: `${Math.random() * 20 + 10}s`,
                animationDelay: `${Math.random() * 5}s`,
              }}
            />
          ))}
        </div>

        <div className="hero-content">
          <h1>Who Are We?</h1>
          <p className="hero-subtitle">
          Where Ideas Ignite and Futures Are Powered
          </p>
          <a href="#aboutus">
          <button className="cta-button">Discover Our Mission</button>
 
          </a>
          <div className="scroll-indicator">
            <span></span>
            <div className="scroll-text">SCROLL TO EXPLORE</div>
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div className="about-container" id="aboutus">
        <section className="about-intro">
          <div className="section-header">
            <h2>About Experience EnergyX Africa</h2>
            <div className="divider"></div>
          </div>
          <div className="intro-content">
            <p className="highlight-text">
              Founded by the visionary entrepreneur Motheo Seleke, a prominent
              figure in the green energy sector, EnergyX Africa is a specialized
              consulting firm dedicated to propelling a just energy transition
              across Southern Africa and the broader Global South.
            </p>
            <p>
              We operate through three foundational pillars, each meticulously
              designed to expedite the journey toward a sustainable and
              equitable energy landscape.
            </p>
          </div>
        </section>

        {/* Services Section */}
        <section className="services-section">
          <div className="section-header">
            <h2>Our Core Pillars</h2>
            <div className="divider"></div>
            <p className="section-subtitle">
              Three interconnected approaches to energy transformation
            </p>
          </div>

          <div className="services-grid">
            {/* Service Card 1 */}
            <div className="service-card">
              <div className="card-icon">
                <FaLightbulb />
              </div>
              <h3>EnergyX Africa Impact</h3>
              <p>
                We transcend traditional consulting; we are strategists, guiding
                public and private sector towards renewable energy solutions.
              </p>
              <ul className="service-features">
                <li>
                  <span>Strategic Advisory:</span> Expert insights on policy,
                  regulation, and market dynamics
                </li>
                <li>
                  <span>Project Development:</span> End-to-end support for
                  renewable energy projects
                </li>
                <li>
                  <span>Climate Finance:</span> Connecting developers with
                  climate funds
                </li>
              </ul>
            </div>

            {/* Service Card 2 */}
            <div className="service-card">
              <div className="card-icon">
                <FaGraduationCap />
              </div>
              <h3>EnergyX Africa Campus</h3>
              <p>
                We are dedicated to cultivating a skilled workforce that
                supports the burgeoning clean energy sector.
              </p>
              <ul className="service-features">
                <li>
                  <span>Skills Development:</span> Customized programs for new
                  entrants
                </li>
                <li>
                  <span>Workplace Immersion:</span> Hands-on skill-building
                  through live projects
                </li>
                <li>
                  <span>Professional Development:</span> Continuous learning
                  opportunities
                </li>
              </ul>
            </div>

            {/* Service Card 3 */}
            <div className="service-card">
              <div className="card-icon">
                <FaHandshake />
              </div>
              <h3>EnergyX Africa Connect</h3>
              <p>
                We bridge the gap between stakeholders in the energy ecosystem
                through innovative platforms and networking opportunities.
              </p>
              <ul className="service-features">
                <li>
                  <span>Conference & Exhibition:</span> Premier industry events
                </li>
                <li>
                  <span>Live Events & Experiences:</span> Engaging stakeholder
                  interactions
                </li>
                <li>
                  <span>Dynamic Reportage:</span> Cutting-edge content
                  generation
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Commitment Section */}
        <section className="commitment-section">
          <div className="section-header">
            <h2>Our Commitment</h2>
            <div className="divider"></div>
          </div>
          <div className="commitment-content">
            <p className="highlight-text">
              At Experience EnergyX Africa , we are passionate about forging a
              sustainable energy future that is inclusive for all in Southern
              Africa and the broader Global South
            </p>

            <div className="commitment-grid">
              <div className="commitment-item">
                <div className="commitment-icon">
                  <FaLeaf />
                </div>
                <h4>Just Transition</h4>
                <p>
                  Promoting principles that ensure fair energy transformation
                  for all communities
                </p>
              </div>

              <div className="commitment-item">
                <div className="commitment-icon">
                  <FaUsers />
                </div>
                <h4>Local Capacity</h4>
                <p>
                  Building skills and infrastructure within African communities
                </p>
              </div>

              <div className="commitment-item">
                <div className="commitment-icon">
                  <FaChartLine />
                </div>
                <h4>Innovation</h4>
                <p>Fostering cutting-edge solutions through collaboration</p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>400+</h3>
              <p>Delegates and Attendees</p>
            </div>
            <div className="stat-item">
              <h3>26+</h3>
              <p>Multi-Sectoral Speakers</p>
            </div>
            <div className="stat-item">
              <h3>27+</h3>
              <p>Industry and Public Sector Partners</p>
            </div>
            <div className="stat-item">
              <h3>34+</h3>
              <p>Multi-Sectoral Exhibitors</p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default About;
